// extracted by mini-css-extract-plugin
export default {"dropContainer":"DropContainer_dropContainer__PLQdW","isImage":"DropContainer_isImage__Pqqd9","isText":"DropContainer_isText__s2n1H"};